import React from "react"
import kocabayfoto from "../images/performance-21711469566536.jpg"
import { Link } from "react-router-dom";

const HeroSection: React.FC = () => {
  return (
    <div className="relative w-full h-[500px] sm:h-[600px] flex items-center justify-center bg-gray-200">
      {/* Background Image */}
      <img
        src={kocabayfoto}// Buraya kendi resim URL'nizi ekleyin
        alt="school transportation"
        className="absolute w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute w-full h-full bg-black/50" />

      {/* Content */}
      <div className="relative z-10 text-white px-6 sm:px-12 md:px-20 lg:px-32 max-w-3xl">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4">
          Güvenli Taşımacılık
        </h1>
        <p className="text-base sm:text-lg md:text-xl mb-6">
          Yolcularımızın güvenliği ve konforu, yolcu taşımacılığımızın temel önceliklerindendir. yolcu taşımacılığında güvenilir bir partner olarak, her gün binlerce yolcuyu okullarına ve evlerine güvenli bir şekilde ulaştırıyoruz.
        </p>
        <Link to="/iletisim" className="bg-[#092049] hover:bg-cyan-600 text-[#D9D9D9] font-bold py-3 px-6 rounded-lg transition-all">
          İletişim
        </Link>
      </div>
    </div>
  );
};

export default HeroSection;
